<template>
  <div class="surface-0 overflow-hidden py-4">
    <div class="py-3 relative" id="hero">
      <div class="mx-4 mt-0 w-100 text-center">
        <div class="text-center mx-6">
          <router-link to="/">
            <img :src="$store.state.master.logo_app" style="width: 100px;" class="" alt="" srcset="">
          </router-link>
        </div>
        <h1 class="text-6xl font-bold text-gray-900 line-height-2 text-center">Form Laporan</h1>
      </div>
    </div>
    <div class="grid mx-1 mb-6">
      <div class="md:col-2"></div>
      <div class="col-12 md:col-8 grid">
				<div class="col-12 md:col-12 w-full p-inputgroup flex-1" v-if="kode">
					<InputText id="password" aria-describedby="password-help" :value="domain + '/?type=' + data.tipe + '&kode=' + kode" readonly/>
					<Button icon="pi pi-clone" label="url" @click="copyData('URL Laporan', domain + '/?type=' + data.tipe + '&kode=' + kode)"/>
					<!-- <Button icon="pi pi-clone" label="kode" @click="copyData('Kode Laporan', kode)"/> -->
					<Button label="open" @click="$router.push('/?type=' + data.tipe + '&kode=' + kode)"/>
				</div>
        <div class="p-buttonset col-12 w-full">
          <Button class="w-6" label="Pengaduan" @click="pilihTipe('pengaduan')" :outlined ="data.tipe != 'pengaduan'" :disabled="loading" />
          <Button class="w-6" label="Permohonan" @click="pilihTipe('permohonan')" :outlined ="data.tipe != 'permohonan'" :disabled="loading" />
        </div>
        <div v-if="data.kode_sebelumnya" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="kode_sebelumnya">Kode Sebelumnya</label>
          <InputText 
            id="kode_sebelumnya" 
            v-model="data.kode_sebelumnya" 
            aria-describedby="kode_sebelumnya-help" 
            :disabled="loading"
            readonly
          />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="asal">Asal Pemohon</label>
          <Dropdown 
            v-model="data.asal" 
            :options="$store.state.data_static.asal_pemohon" 
            optionLabel="text" 
            optionValue="value" 
            placeholder="piilh asal pemohon" 
            class="w-full" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.asal.$invalid && afterClickSubmit }" 
          />
        </div>
        <div v-if="data.asal == 'dosen' || data.asal == 'mahasiswa'" class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="fakultas">Fakultas</label>
          <Dropdown 
            v-model="data.fakultas_id" 
            optionLabel="nama_fakultas" 
            optionValue="id" 
            :options="list_fakultas" 
            placeholder="pilih fakultas" 
            class="w-full" 
            @change="getProdi()" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.fakultas_id.$invalid && afterClickSubmit }" 
          />
        </div>
        <div v-if="data.asal == 'dosen' || data.asal == 'mahasiswa'" class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="prodi">Prodi</label>
          <Dropdown 
            v-model="data.prodi_id" 
            optionLabel="nama_prodi" 
            optionValue="id" 
            :options="list_prodi" 
            placeholder="pilih prodi" 
            class="w-full" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.prodi_id.$invalid && afterClickSubmit }" 
          />
        </div>
        <div v-if="data.asal == 'tendik'" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="biro">Biro</label>
          <Dropdown 
            v-model="data.biro_id" 
            optionLabel="nama_biro" 
            optionValue="id" 
            :options="list_biro" 
            placeholder="pilih biro" 
            class="w-full" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.biro_id.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="kategori">Kategori</label>
          <Dropdown 
            v-model="data.kategori_id" 
            optionLabel="nama_kategori" 
            :options="list_kategori" 
            placeholder="pilih kategori" 
            class="w-full" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.kategori_id.$invalid && afterClickSubmit }" 
          />
        </div>
        <!-- <div class="col-12 md:col-12 flex flex-column gap-2 mt-1"><hr></div> -->
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="nama">Nama Pemohon</label>
          <InputText 
            id="nama" 
            v-model="data.nama" 
            aria-describedby="nama-help" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.nama.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="no_identitas">No Identitas</label>
          <InputText 
            id="no_identitas" 
            v-model="data.no_identitas" 
            aria-describedby="no_identitas-help" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.no_identitas.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="no_hp">No Handphone</label>
          <InputText 
            id="no_hp" 
            v-model="data.no_hp" 
            aria-describedby="no_hp-help" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.no_hp.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="email">Email</label>
          <InputText 
            id="email" 
            v-model="data.email" 
            aria-describedby="email-help" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.email.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="upload_foto">Lampirkan Foto Identitas Diri (KTP / KTM / SIM / Passport)</label>
          <FileUpload 
            :model="data.foto"
            name="upload_foto" 
            ref='image'
            accept="image/*"
            :previewWidth="100" 
            @select="uploadImage($event)" 
            @remove="uploadImage($event)" 
            :multiple="false" 
            :maxFileSize="1000000"
            :showUploadButton="false"
            :showCancelButton="false"
            chooseLabel="upload Image"
            :disabled="data.foto_identitas.length >= 1 || loading"
            :pt="{
                root: { style: v$.data.foto_identitas.$invalid && afterClickSubmit ? 'border: 1px solid red; border-radius: 7px;' : '' }
            }"
          >
            <template #empty>
              <p>Drag and drop files to here to upload.</p>
            </template>
          </FileUpload>
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="deskripsi">Deskripsi</label>
          <Textarea 
            id="deskripsi" 
            v-model="data.deskripsi" 
            aria-describedby="deskripsi-help" 
            :disabled="loading" 
            :class="{ 'p-invalid': v$.data.deskripsi.$invalid && afterClickSubmit }" 
          />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="upload_file">Jika Mmembutuhkan Data Pendukung Bisa Dilampirkan ( .jpeg / .jpg / .png / .pdf )</label>
          <FileUpload 
            name="upload_file" 
            ref='file'
            :previewWidth="0" 
            @select="uploadFile($event)" 
            @remove="uploadFile($event)" 
            :multiple="false" 
            accept="" 
            :maxFileSize="1000000"
            :showUploadButton="false"
            :showCancelButton="false"
            chooseLabel="upload File"
            :disabled="data.file_laporan.length >= 2 || loading"
          >
            <template #empty>
              <p>Drag and drop files to here to upload.</p>
            </template>
          </FileUpload>
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <div class="flex align-items-center">
            <Checkbox v-model="accept" inputId="accept" name="accept" :value="true" :binary="true" />
            <label for="accept" class="ml-2"> Dengan ini saya menyatakan bahwa data yang saya isikan dan lampirkan adalah data yang benar, jika ditemukan hari ditemukan penipuan / pemalsuan / kesalahan data maka saya siap bertanggung jawab </label>
          </div>

          <!-- DENGAN INI SAYA MENYATAKAN BAHWA DATA YANG SAYA ISIKAN DAN LAMPIRKAN ADALAH DATA YANG BENAR, JIKA DIKEMUDIAN HARI DITEMUKAN PENIPUAN / PEMALSUAN / KESALAHAN DATA MAKA SAYA SIAP BERTANGGUNGJAWAB -->
          
        </div>
        <Button class="w-full mt-3" label="Upload Laporan" @click="register()" :disabled="loading || !accept" />
      </div>
      <div class="md:col-2"></div>
      <div class="md:col-2"></div>
      <div class="md:col-10 mt-1">
        <span>
          sudah mepunyai laporan?, untuk melihat laporan yang telah anda buat silahkan 
          <router-link to="/">klik disini</router-link>
        </span>
      </div>
      <div class="md:col-2"></div>
    </div>
  </div>
</template>


<script>
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, email, numeric } from '@vuelidate/validators'
import { load } from 'recaptcha-v3'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return {
			domain: window.location.origin,
      kode: '',
      accept: false,
			loading: false,
			afterClickSubmit: false,
      data: {
        tipe: 'pengaduan',
        nama: null,
        asal: null,
        no_identitas: null,
        no_hp: null,
        email: null,
        deskripsi: null,
        foto_identitas: [],
        file_laporan: [],
        prodi_id: null,
        fakultas_id: null,
        biro_id: null,
        kategori_id: null,
      },
      list_kategori: [],
      list_fakultas: [],
      list_prodi: [],
      list_biro: [],
      recaptcha: null,
    }
  },
  computed: {
    isValid() {
      return !this.v$.data.$invalid;
    },
  },
  validations () {
    return {
      data: {
        tipe: { required },
        nama: { required },
        asal: { required },
        no_identitas: { required, numeric },
        no_hp: { required, numeric },
        email: { required, email },
        deskripsi: { required },
        foto_identitas: { required },
        file_laporan: {  },
        prodi_id: { required: requiredIf(() => {return this.data.asal == 'mahasiswa'})},
        fakultas_id: { required: requiredIf(() => {return this.data.asal == 'mahasiswa'})},
        biro_id: { required: requiredIf(() => {return this.data.asal == 'tendik'})},
        kategori_id: { required },
      }
    }
  },
  async mounted() {
    const vm = this
    vm.data.tipe = vm.$route.query.type || vm.$store.state.data_static.jenis_kategori[1].value
    vm.data.kode_sebelumnya = vm.$route.query.kode
    vm.pilihTipe(vm.data.tipe)
    
    vm.list_fakultas = (await vm.$axios.post('fakultas/list')).data.data.map(x => {
      return {
        ...x
      }
    })
    vm.list_biro = (await vm.$axios.post('biro/list')).data.data.map(x => {
      return {
        ...x
      }
    })
    vm.recaptcha = await load(process.env.VUE_APP_KEYSITECAPTCHA, {
      // autoHideBadge: true,
    })
  },
  methods: {
    async copyData(nama, url){
      const vm = this
      await navigator.clipboard.writeText(url);
			vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: `Berhasil Copy ${nama}`, life: 3000 });
    },
    uploadImage(e){
      const vm = this
      vm.data.foto_identitas = e.files
    },
    uploadFile(e){
      const vm = this
      vm.data.file_laporan = e.files
    },
    async pilihTipe(x){
      const vm = this
      vm.data.tipe = x
      vm.list_kategori = (await vm.$axios.post('kategori/list', {jenis_kategori: x})).data.data.map(x => {
        return {
          ...x
        }
      })
    },
    async getProdi(){
      const vm = this
      vm.data.prodi_id = null
      vm.list_prodi = (await vm.$axios.post('prodi/list', {fakultas_id: vm.data.fakultas_id})).data.data.map(x => {
        return {
          ...x
        }
      })
    },
    async register(){
      const vm = this
      try {
        vm.loading = true
        vm.afterClickSubmit = true
        if(vm.isValid){
          const captcha = await vm.recaptcha.execute('login')
          // const captcha = 123
          // console.log('captcha', captcha) // Will also print the token
          // console.log(vm.data)
          let data = new FormData()
          data.append('captcha', captcha)
          if(vm.data.foto_identitas[0]) data.append('file1', vm.data.foto_identitas[0])
          if(vm.data.file_laporan[0]) data.append('file2', vm.data.file_laporan[0])
          if(vm.data.file_laporan[1]) data.append('file3', vm.data.file_laporan[1])
          if(vm.data.kode_sebelumnya) data.append('kode_' + vm.data.tipe + '_sebelumnya', vm.data.kode_sebelumnya)
          data.append('nama_pemohon', vm.data.nama)
          data.append('asal_pemohon', vm.data.asal)
          data.append('no_identitas', vm.data.no_identitas)
          data.append('no_hp_pemohon', vm.data.no_hp)
          data.append('email_pemohon', vm.data.email)
          data.append('deskripsi_' + vm.data.tipe, vm.data.deskripsi)
          data.append('foto_identitas', vm.data.foto_identitas)
          data.append('file_laporan', vm.data.file_laporan)
          if(vm.data.prodi_id && vm.data.asal == 'mahasiswa') data.append('prodi_id', vm.data.prodi_id)
          if(vm.data.fakultas_id && vm.data.asal == 'mahasiswa' && vm.data.asal == 'mahasiswa') data.append('fakultas_id', vm.data.fakultas_id)
          if(vm.data.biro_id && vm.data.asal == 'tendik') data.append('biro_id', vm.data.biro_id)
          if(vm.data.kategori_id) data.append('kategori_id', vm.data.kategori_id.id)
          if(vm.data.kategori_id) data.append('kode_kategori', vm.data.kategori_id.kode_kategori)
          let result = await vm.$axios.post(vm.data.tipe + '/register', data)
          if(result.data.status == 200){
            // console.log('result', result.data)
            vm.kode = result.data.data['kode_' + vm.data.tipe]
            if(vm.data.foto_identitas.length > 0) vm.$refs.file.files = []
            if(vm.data.file_laporan.length > 0) vm.$refs.image.files = []
            vm.data.foto_identitas = []
            vm.data.file_laporan = []
            vm.data = {
              tipe: vm.data.tipe,
              nama: null,
              asal: null,
              no_identitas: null,
              no_hp: null,
              email: null,
              deskripsi: null,
              foto_identitas: [],
              file_laporan: [],
              prodi_id: null,
              fakultas_id: null,
              biro_id: null,
              kategori_id: null,
            }
            vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Membuat Laporan', life: 3000 });
            vm.afterClickSubmit = false
          }else{
            vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Membuat Laporan', life: 3000 });
          }
        }else{
          vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Data Tidak Valid', life: 3000 });
        }
        vm.loading = false
      } catch (error) {
        // console.log('error', error)
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: error.response.data.message, life: 3000 });
      }
    },
  },
}
</script>

<style>
</style>